/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { ConversationalAgentStateSchemaDetail } from './ConversationalAgentStateSchemaDetail';
import {
  ConversationalAgentStateSchemaDetailFromJSON,
  ConversationalAgentStateSchemaDetailFromJSONTyped,
  ConversationalAgentStateSchemaDetailToJSON,
} from './ConversationalAgentStateSchemaDetail';

/**
 *
 * @export
 * @interface VoiceAgentDataset
 */
export interface VoiceAgentDataset {
  /**
   *
   * @type {number}
   * @memberof VoiceAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof VoiceAgentDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {ConversationalAgentStateSchemaDetail}
   * @memberof VoiceAgentDataset
   */
  readonly stateSchema: ConversationalAgentStateSchemaDetail;
  /**
   *
   * @type {boolean}
   * @memberof VoiceAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VoiceAgentDataset
   */
  readonly hasState: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VoiceAgentDataset
   */
  readonly hasTokenUsage: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof VoiceAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof VoiceAgentDataset
   */
  audioRecordings?: Array<number>;
}

/**
 * Check if a given object implements the VoiceAgentDataset interface.
 */
export function instanceOfVoiceAgentDataset(value: object): value is VoiceAgentDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('stateSchema' in value) || value['stateSchema'] === undefined) return false;
  if (!('hasState' in value) || value['hasState'] === undefined) return false;
  if (!('hasTokenUsage' in value) || value['hasTokenUsage'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function VoiceAgentDatasetFromJSON(json: any): VoiceAgentDataset {
  return VoiceAgentDatasetFromJSONTyped(json, false);
}

export function VoiceAgentDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoiceAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    stateSchema: ConversationalAgentStateSchemaDetailFromJSON(json['state_schema']),
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'],
    hasTokenUsage: json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    audioRecordings: json['audio_recordings'] == null ? undefined : json['audio_recordings'],
  };
}

export function VoiceAgentDatasetToJSON(
  value?: Omit<VoiceAgentDataset, 'id' | 'hasPredictions' | 'stateSchema' | 'hasState' | 'hasTokenUsage'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    evaluate_state: value['evaluateState'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    audio_recordings: value['audioRecordings'],
  };
}
